export default __webpack_public_path__ + "static/media/impossible.56046643.svg";